import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { Resident } from "@graphql/api";
import { mapSiteAddress } from "@utils";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}
export default function PersonalDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Name",
          value: (
            <LoadingOrValue
              loading={!resident?.firstName && isLoading}
              value={`${resident?.firstName} ${resident?.lastName}`}
              height={28}
              width={150}
            />
          ),
          gridSize: 6,
        },
        {
          label: "Current or Former Resident",
          value: (
            <LoadingOrValue
              loading={resident?.isCurrentResident === undefined && isLoading}
              value={resident?.isCurrentResident ? "Current" : "Former"}
              height={28}
              width={150}
            />
          ),
          gridSize: 6,
        },
        {
          label: "Site Address",
          value: (
            <LoadingOrValue
              loading={!resident?.siteAddress && isLoading}
              value={`${mapSiteAddress(resident?.siteAddress)}`}
              height={28}
              width={300}
            />
          ),
          gridSize: 12,
        },
        ...(resident?.siteAddress?.spaceCode
          ? [
              {
                label: "Space Code",
                value: (
                  <LoadingOrValue
                    loading={!resident?.siteAddress && isLoading}
                    value={resident.siteAddress.spaceCode}
                    height={28}
                    width={150}
                  />
                ),
                gridSize: 6 as const,
              },
            ]
          : []),
        ...(resident?.siteAddress?.type
          ? [
              {
                label: "Site Address Type",
                value: (
                  <LoadingOrValue
                    loading={!resident?.siteAddress && isLoading}
                    value={resident.siteAddress.type}
                    height={28}
                    width={150}
                  />
                ),
                gridSize: 6 as const,
              },
            ]
          : []),
      ]}
    />
  );
}
